import moment from 'moment';
const formatDate = (date) => {
    return moment(date).format("DD-MMM-YYYY");
}

export { formatDate }


// WEBPACK FOOTER //
// ./src/new/Utils/format-date.js